<template>
    <v-container fluid grid-list-xl>
        <v-layout row wrap>
            <v-flex md3 lg2>
                <v-text-field v-model="query.phone" label="手机号" class="pr-2" v-on:keyup.enter="getList()"></v-text-field>
            </v-flex>


            <v-flex md3 lg2>
                <div>
                    <v-select v-model="query.pageSize" :items="pageSizes" item-text="label" @change="getList()"
                        item-value="value" label="每页条数" class="pr-2 inline-block" required></v-select>
                </div>
            </v-flex>

            <v-flex xs-12 md-12 lg-12 sm-12>
                <v-btn color="gray" @click="resetSearch()">重置</v-btn>
                <v-btn color="dark" @click="getList()">
                    <v-icon size="14">mdi-account-search</v-icon>&nbsp;搜索
                </v-btn>

          

            </v-flex>

        </v-layout>

        <v-divider></v-divider>

        <v-layout wrap justify-space-between>


        </v-layout>

        <v-layout row wrap>
            <v-flex xs-12 md-12 lg-12 sm-12>
                <el-table ref="multipleTable" :data="items" tooltip-effect="dark" style="width: 100%" border
                    v-loading="tableLoad" @selection-change="handleSelectionChange">

                    <el-table-column label="校区ID" prop="a_id"></el-table-column>
                    <el-table-column label="餐厅id" prop="id"></el-table-column>
                    <el-table-column label="餐厅名称" prop="server_name"></el-table-column>
                    <el-table-column label="外卖校区ID" prop="su_id"></el-table-column>
                    <!-- <el-table-column label="Openid" prop="_openid"></el-table-column>
                    <el-table-column label="账号" prop="username"></el-table-column>
                    <el-table-column label="密码" prop="password"></el-table-column> -->

                    <el-table-column label="总盈利额">
                        <template slot-scope="scope">
                            <div>￥{{ Number(scope.row.dl_balance).toFixed(2) }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="已提现额">
                        <template slot-scope="scope">
                            <div>￥{{ Number(scope.row.dl_cash).toFixed(2) }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="可提现额">
                        <template slot-scope="scope">
                            <div>￥{{ Number(scope.row.dl_balance - scope.row.dl_cash).toFixed(2) }}</div>
                        </template>
                    </el-table-column>

                    <!-- <el-table-column prop label="是否允许提现">
                        <template slot-scope="scope">
                            <div>
                                <div>{{ scope.row.can_cash ? '正常' : '冻结' }}</div>


                            </div>
                        </template>
                    </el-table-column> -->


                    <el-table-column label="操作">

                        <template slot-scope="scope">

                            <!-- <v-btn small slot="activator" color="success" @click="editIt(scope.row)">
                                编辑
                            </v-btn>

                            <v-btn small slot="activator" color="red" @click="delIt(scope.row)">
                                删除
                            </v-btn> -->

                            <v-btn small slot="activator" color="warning" @click="cashIt(scope.row)">
                                提现
                            </v-btn>
                            <v-dialog v-model="dialog2" persistent max-width="600px">

                                <v-card>
                                    <v-card-title>
                                        <span class="text-h5">餐厅提现</span>
                                    </v-card-title>
                                    <v-card-text>
                                        <v-container>

                                            <v-flex xs12 md6>
                                                <v-text-field label="餐厅名称" v-model="currentData.server_name"
                                                    disabled></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 md6>
                                                <v-text-field label="餐厅ID" v-model="currentData.id"
                                                    disabled></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 md6>
                                                <v-text-field label="手机号" v-model="currentData.phone"
                                                    disabled></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 md6>
                                                <v-text-field label="总盈利额" v-model="currentData.dl_balance"
                                                    disabled></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 md6>
                                                <v-text-field label="已提现额" v-model="currentData.dl_cash"
                                                    disabled></v-text-field>
                                            </v-flex>

                                            <v-flex xs12 md6>
                                                <v-text-field label="可提现额" :placeholder="Number(currentData.dl_balance -
                                                    currentData.dl_cash).toFixed(2)" disabled></v-text-field>
                                            </v-flex>

                                            <small style="color: red;">* 本次最大的提现金额为 ￥ {{ Number(currentData.dl_balance -
                                                currentData.dl_cash).toFixed(2) }}</small>
                                            <v-flex xs12 md6>
                                                <v-text-field label="请输入本次提现金额" v-model="currentData.num"></v-text-field>
                                            </v-flex>
                                        </v-container>

                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="blue darken-1" text @click="dialog2 = false">
                                            关闭
                                        </v-btn>
                                        <v-btn color="blue darken-1" text @click="createCash">
                                            提交
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </template>
                    </el-table-column>
                </el-table>
            </v-flex>
        </v-layout>
        <v-layout wrap justify-end mt-3>
            <el-pagination @current-change="handleCurrentChange" :current-page="query.currentPage"
                :page-size="query.pageSize" layout="total,  prev, pager, next, jumper" :total="total"></el-pagination>
        </v-layout>
        <!-- <detail v-model='dialog' :msg="tempData" @change="updateMsgChange" @changemsg="changeMsg" />
         -->

    </v-container>
</template>
<script>

let _this;
export default {

    props: {
        load: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        load(val) {
            if (val) {
                this.pageLoad = val
            }
        },
        pageLoad(val) {
            if (val) {
                this.getList();
            }
        }
    },
    data() {
        return {
            dialog3: false,
            pageLoad: false,
            dialog: false,
            dialog2: false,
            currentData: {},
            addData: {},
            tempData: {},
            items: [],
            query: {
                phone: '',
                currentPage: 1,
                pageSize: 10
            },
            multipleSelection: [],
            pageSizes: this.$pageSizes,
            tableLoad: false,
            total: 0,
        };
    },
    mounted() {
        _this = this;
        this.getList();
    },
    methods: {
        // async doAdd(){
        // const res = await this.$post('admin/createDlInfo',this.addData)
        // if(res.errno === 0){
        //     this.dialog3 = false 
        //     this.addData = {}
        //     this.$message({message:'添加成功',type:'success'})
        //     this.getList()
        // }
        // },
        // async delIt(e){
        //     this.$confirm(`用户${e.username},是否删除当前代理商?`).then(async r => {
        //         if (r == 'confirm') {
        //             const res = await this.$post('admin/delDlInfo',e)
        //             this.$message({message:'删除成功',type:'success'})
        //     this.getList()
        //         }
        //     })
        // },
        //获取列表
        updateMsgChange(val) {
            this.dialog = val
        },
        async createCash() {
            if (Number(this.currentData.num) > Number(this.currentData.dl_balance - this.currentData.dl_cash)) {
                this.$message({
                    message: '提现金额填写错误！',
                    type: 'danger'
                })
                return
            }
            if (Number(this.currentData.num) > 0) {
                this.currentData.state = 3
                const res = await this.$post('admin/CanTingCash', this.currentData)
                this.$message({
                    message: '操作成功！',
                    type: 'success'
                })
                this.$router.push({ path: 'cash' })

            }
            this.currentData = {}
            this.dialog2 = false
        },
        editIt(e) {

            this.dialog = true
            this.tempData = e

        },
        async cashIt(e) {

            this.dialog2 = true

            this.currentData = e

        },

        async getList() {
            this.tableLoad = true;
            const res= await this.$post('alipay/getAllCT');
            _this.tableLoad = false;
            if (res.errno === 0) {
              _this.items = res.data;             
            }

        },
        //重置搜索
        resetSearch() {
            this.query.orderNum = '';
            this.query.status = '';
            this.getList();
        },

        //选中
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },

        //获取id
        getIds() {
            let arr = [];
            for (let i in this.multipleSelection) {
                arr.push(this.multipleSelection[i].id)
            }
            return arr
        },

        //跳转页码
        handleCurrentChange(val) {
            this.query.currentPage = val;
            this.getList();
        },


        //更新值
        changeMsg(e) {
            this.getList()
        }

    }
};
</script>
